import { fromJS } from 'immutable';

import {
  LOAD_CAMPAIGN_ANALYTICS,
  LOAD_CAMPAIGN_ANALYTICS_SUCCESS,
  LOAD_CAMPAIGN_ANALYTICS_ERROR,
  UPDATE_CAMPAIGN_ANALYTICS,
  UPDATE_CAMPAIGN_ANALYTICS_TOTALS,
  LOAD_CAMPAIGN_ANALYTICS_SET_LOADING,
} from './constants';

const initialState = fromJS({
  youtubeVideos: {},
  facebookPosts: {},
  twitterPosts: {},
  instagramPosts: {},
  hasTrackedDeliverables: false,
  youtubeTotals: {},
  instagramTotals: {},
  facebookTotals: {},
  twitterTotals: {},
  loading: false,
  error: null,
});

function campaignAnalyticsReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_CAMPAIGN_ANALYTICS:
    return state
      .set('youtubeVideos', fromJS({}))
      .set('facebookPosts', fromJS({}))
      .set('twitterPosts', fromJS({}))
      .set('instagramPosts', fromJS({}))
      .set('youtubeTotals', fromJS({}))
      .set('instagramTotals', fromJS({}))
      .set('twitterTotals', fromJS({}))
      .set('hasTrackedDeliverables', false)
      .set('error', null);
  case LOAD_CAMPAIGN_ANALYTICS_SET_LOADING:
    return state
      .set('loading', action.loading);
  case LOAD_CAMPAIGN_ANALYTICS_SUCCESS:
    return state
      .set('loading', false)
      .set('youtubeVideos', action.youtubeVideos)
      .set('facebookPosts', action.facebookPosts)
      .set('twitterPosts', action.twitterPosts)
      .set('instagramPosts', action.instagramPosts)
      .set('youtubeTotals', action.youtubeTotals)
      .set('instagramTotals', action.instagramTotals)
      .set('facebookTotals', action.facebookTotals)
      .set('twitterTotals', action.twitterTotals)
      .set('hasTrackedDeliverables', action.hasTrackedDeliverables);
  case LOAD_CAMPAIGN_ANALYTICS_ERROR:
    return state
      .set('loading', false)
      .set('error', action.error);
  case UPDATE_CAMPAIGN_ANALYTICS:
    return state
      .set('hasTrackedDeliverables', true)
      .setIn([action.assetList, action.assetId], action.newAsset);
  case UPDATE_CAMPAIGN_ANALYTICS_TOTALS:
    return state
      .set('youtubeTotals', action.youtubeTotals)
      .set('instagramTotals', action.instagramTotals)
      .set('facebookTotals', action.facebookTotals)
      .set('twitterTotals', action.twitterTotals);
  default:
    return state;
  }
}

export default campaignAnalyticsReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-analytics/reducer.js
 **/